import type { DataItem } from '@pn/core/domain/data';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type InitialState = {
  isFetching: boolean;
  isError: boolean;
  stats: Record<string, DataItem[]>;
  loadedFormationIds: string[];
};

const initialState: InitialState = {
  isFetching: false,
  isError: false,
  stats: {},
  loadedFormationIds: [],
};

const createFormationsStatsSlice = (sliceName: string) =>
  createSlice({
    name: sliceName,
    initialState,
    reducers: {
      request: (state) => {
        state.isFetching = true;
      },
      receive: (
        state,
        action: PayloadAction<{ formationId: string; stats: DataItem[] }>
      ) => {
        state.stats[action.payload.formationId] = action.payload.stats;
        state.loadedFormationIds.push(action.payload.formationId);
        state.isFetching = false;
      },
      error: (state) => {
        state.isFetching = false;
        state.isError = true;
      },
      reset: (state) => {
        state.isFetching = false;
        state.isError = false;
        state.stats = {};
        state.loadedFormationIds = [];
      },
    },
  });

export const formationsStatsSlice = createFormationsStatsSlice(
  'formationsStatsStats'
);
